export const CheckboxTheme = {
    Checkbox: {
        baseStyle: {
        }
    }
}